import { render } from "./codigovestimenta.vue?vue&type=template&id=79d7f85a&scoped=true"
import script from "./codigovestimenta.vue?vue&type=script&lang=js"
export * from "./codigovestimenta.vue?vue&type=script&lang=js"

import "./codigovestimenta.vue?vue&type=style&index=0&id=79d7f85a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79d7f85a"]])

export default __exports__